import { path } from 'ramda';

import { PAGES_STORE_KEY } from '@/redux/constants';

export const getItemsRoot = path([PAGES_STORE_KEY, 'personnelPage', 'items']);

export const getQueryRoot = path([PAGES_STORE_KEY, 'personnelPage', 'query']);
